module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Do the Stuff You Don’t Want to Do")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter02#ch-2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Learn How to Shoulder Someone Else’s Dreams")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Diapers Don’t Have a Shelf Life (AKA: Shit Happens)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap4"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Be Willing to Be Inconsistent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap5"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Go to the Funeral")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap6"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Sometimes Quitting Is the Best Way Forward")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap7"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("There Is No Secret to Survival")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap7"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Bet Your Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap7"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Live Your Own Lie—and Do It Honestly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap7"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Count Your Traumas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap6"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Why Not Me?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap5"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Don’t Be Afraid to Be Boring")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Don’t Worry about Doing the Right Thing (Because You Probably Already Know What It Is)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Don’t "), _c('em', [_vm._v("Leave")]), _vm._v(" a Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Ack#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0fd014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0